<div class="layout-sidebar">
  <div class="sidebar-header">
    <img src="assets/Novatellus_Light.svg" alt="Novatellus" class="sidebar-logo" />
  </div>
  <!-- Navigazione principale: la regione permette di saltarci direttamente
       invece di attraversare la pagina (WCAG 1.3.1). -->
  <nav class="layout-menu-container" aria-label="Navigazione principale">
    <div class="layout-menu">
      <ui-menu-item *ngFor="let item of topBar" [item]="item" />
    </div>
    <div class="layout-menu">
      <ui-menu-item *ngFor="let item of bottomBar" [item]="item" />
    </div>
  </nav>
</div>
